/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiWebhookTrigger } from './ApiWebhookTrigger';
import {
    ApiWebhookTriggerFromJSON,
    ApiWebhookTriggerFromJSONTyped,
    ApiWebhookTriggerToJSON,
    ApiWebhookTriggerToJSONTyped,
} from './ApiWebhookTrigger';

/**
 * a Webhook
 * @export
 * @interface ApiCreateWebhook
 */
export interface ApiCreateWebhook {
    /**
     * 
     * @type {ApiWebhookTrigger}
     * @memberof ApiCreateWebhook
     */
    trigger?: ApiWebhookTrigger;
    /**
     * Destination URL
     * @type {string}
     * @memberof ApiCreateWebhook
     */
    url: string;
    /**
     * Authentication token. Will be sent with each webhook requests "X-Salv-Token" header if set.
     * @type {string}
     * @memberof ApiCreateWebhook
     */
    token?: string;
}



/**
 * Check if a given object implements the ApiCreateWebhook interface.
 */
export function instanceOfApiCreateWebhook(value: object): value is ApiCreateWebhook {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function ApiCreateWebhookFromJSON(json: any): ApiCreateWebhook {
    return ApiCreateWebhookFromJSONTyped(json, false);
}

export function ApiCreateWebhookFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiCreateWebhook {
    if (json == null) {
        return json;
    }
    return {
        
        'trigger': json['trigger'] == null ? undefined : ApiWebhookTriggerFromJSON(json['trigger']),
        'url': json['url'],
        'token': json['token'] == null ? undefined : json['token'],
    };
}

export function ApiCreateWebhookToJSON(json: any): ApiCreateWebhook {
    return ApiCreateWebhookToJSONTyped(json, false);
}

export function ApiCreateWebhookToJSONTyped(value?: ApiCreateWebhook | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'trigger': ApiWebhookTriggerToJSON(value['trigger']),
        'url': value['url'],
        'token': value['token'],
    };
}

